// Предложение включить уведомления при входе: без него игрок узнаёт о них только из настроек.
import { errorText } from '@/lib/errors';
import { enablePush, pushOffered, shouldOfferPush } from '@/lib/pwa';
import { useGame } from '@/store/game';
import { BottomSheet, Button } from '@/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OFFER_DELAY_MS = 2500;

export function PushOffer() {
  const { t } = useTranslation();
  const toast = useGame((s) => s.toast);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const id = window.setTimeout(() => {
      void shouldOfferPush().then(setOpen);
    }, OFFER_DELAY_MS);
    return () => window.clearTimeout(id);
  }, []);
  const close = () => {
    pushOffered();
    setOpen(false);
  };
  const enable = async () => {
    setBusy(true);
    try {
      const state = await enablePush();
      if (state === 'on') toast(t('game:pushOffer.done'), 'success');
      else if (state === 'blocked') toast(t('game:pushOffer.blocked'), 'warning');
    } catch (e) {
      toast(errorText(e), 'error');
    } finally {
      setBusy(false);
      close();
    }
  };
  return (
    <BottomSheet open={open} onClose={close} title={`🔔 ${t('game:pushOffer.title')}`}>
      <div className="space-y-3">
        <p>{t('game:pushOffer.text')}</p>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="secondary" disabled={busy} onClick={close}>
            {t('game:pushOffer.later')}
          </Button>
          <Button loading={busy} onClick={enable}>
            {t('game:pushOffer.enable')}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
}
